import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";

export default {
    name: "DamageLossesDetail",
    components: {
        MainLayout,
        Loading
    },

    data() {
        return {
            noDataMsg: CONFIG.NO_DATA_EXIST,
            bookTypeOptions: CONFIG.BOOK_TYPE,
            isLoading: false,
            damageLossesData: {}
        };
    },

    methods: {
        getDamageLossesDetailById() {
            axios.get('damageAndLoss/detail/' + this.$route.params.id)
                .then((response) => {
                    if (response.data != undefined) {
                        this.damageLossesData = response.data;
                    }
                    this.isLoading = false;
                })
                .catch((error) => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        showList() {
            this.$router.push({
                path: "/damageLosses/list"
            });
        },

        formatDescription(description) {
            return description ? description.replace(/\n/g, '<br>') : '';
        },
        
    },
    mounted() {
        this.isLoading = true;
        this.getDamageLossesDetailById();
    },
};
